module.exports = __webpack_public_path__ + "img/359e2d2.png";